const actions = {
  LOAD_ASAAS_ACCOUNT_REQUEST: 'ASAAS_LOAD_ACCOUNT_REQUEST',
  LOAD_ASAAS_ACCOUNT_SUCCESS: 'ASAAS_LOAD_ACCOUNT_SUCCESS',
  SETUP_ASAAS_ACCOUNT_REQUEST: 'ASAAS_SETUP_ACCOUNT_REQUEST',
  SETUP_ASAAS_ACCOUNT_SUCCESS: 'ASAAS_SETUP_ACCOUNT_SUCCESS',
  SETUP_ASAAS_ACCOUNT_ERROR: 'ASAAS_SETUP_ACCOUNT_ERROR',
  GET_ASAAS_ACCOUNT_STATUS_REQUEST: 'ASAAS_GET_ACCOUNT_STATUS_REQUEST',
  GET_ASAAS_ACCOUNT_STATUS_SUCCESS: 'ASAAS_GET_ACCOUNT_STATUS_SUCCESS',
  GET_ASAAS_ACCOUNT_STATUS_ERROR: 'ASAAS_GET_ACCOUNT_STATUS_ERROR',
  SEARCH_ZIP_CODE_REQUEST: 'ASAAS_SEARCH_ZIP_CODE_REQUEST',
  SEARCH_ZIP_CODE_SUCCESS: 'ASAAS_SEARCH_ZIP_CODE_SUCCESS',
  LOAD_ASAAS_FEES_REQUEST: 'ASAAS_LOAD_FEES_REQUEST',
  LOAD_ASAAS_FEES_SUCCESS: 'ASAAS_LOAD_FEES_SUCCESS',
  LOAD_ASAAS_FEES_ERROR: 'ASAAS_LOAD_FEES_ERROR',
  CANCEL_ASAAS_CHARGE_REQUEST: 'ASAAS_CANCEL_CHARGE_REQUEST',
  CANCEL_ASAAS_CHARGE_SUCCESS: 'ASAAS_CANCEL_CHARGE_SUCCESS',
  CANCEL_ASAAS_CHARGE_ERROR: 'ASAAS_CANCEL_CHARGE_ERROR',
  REFUND_ASAAS_CHARGE_REQUEST: 'ASAAS_REFUND_CHARGE_REQUEST',
  REFUND_ASAAS_CHARGE_SUCCESS: 'ASAAS_REFUND_CHARGE_SUCCESS',
  REFUND_ASAAS_CHARGE_ERROR: 'ASAAS_REFUND_CHARGE_ERROR',
  CHECK_REFUND_STATUS_REQUEST: 'ASAAS_CHECK_REFUND_STATUS_REQUEST',
  CHECK_REFUND_STATUS_SUCCESS: 'ASAAS_CHECK_REFUND_STATUS_SUCCESS',
  CHECK_REFUND_STATUS_ERROR: 'ASAAS_CHECK_REFUND_STATUS_ERROR',
  LOAD_ASAAS_CHARGES_REQUEST: 'ASAAS_LOAD_CHARGES_REQUEST',
  ASAAS_CHARGES_UPDATED: 'ASAAS_CHARGES_UPDATED',
  LOAD_ASAAS_CHARGES_ERROR: 'ASAAS_LOAD_CHARGES_ERROR',
  GET_CHECKOUT_INFO_REQUEST: 'ASAAS_GET_CHECKOUT_INFO_REQUEST',
  GET_CHECKOUT_INFO_SUCCESS: 'ASAAS_GET_CHECKOUT_INFO_SUCCESS',
  GET_CHECKOUT_INFO_ERROR: 'ASAAS_GET_CHECKOUT_INFO_ERROR',
  VALIDATE_CHECKOUT_CPF_REQUEST: 'ASAAS_VALIDATE_CHECKOUT_CPF_REQUEST',
  VALIDATE_CHECKOUT_CPF_SUCCESS: 'ASAAS_VALIDATE_CHECKOUT_CPF_SUCCESS',
  VALIDATE_CHECKOUT_CPF_ERROR: 'ASAAS_VALIDATE_CHECKOUT_CPF_ERROR',
  CREATE_PUBLIC_CHARGE_REQUEST: 'ASAAS_CREATE_PUBLIC_CHARGE_REQUEST',
  CREATE_PUBLIC_CHARGE_SUCCESS: 'ASAAS_CREATE_PUBLIC_CHARGE_SUCCESS',
  CREATE_PUBLIC_CHARGE_ERROR: 'ASAAS_CREATE_PUBLIC_CHARGE_ERROR',
  CLEAR_CHECKOUT_CHARGE: 'ASAAS_CLEAR_CHECKOUT_CHARGE',
  CREATE_CHECKOUT_CHARGE_REQUEST: 'ASAAS_CREATE_CHECKOUT_CHARGE_REQUEST',
  CREATE_CHECKOUT_CHARGE_SUCCESS: 'ASAAS_CREATE_CHECKOUT_CHARGE_SUCCESS',
  CREATE_CHECKOUT_CHARGE_ERROR: 'ASAAS_CREATE_CHECKOUT_CHARGE_ERROR',
  SIMULATE_ASAAS_PAYMENT_REQUEST: 'ASAAS_SIMULATE_PAYMENT_REQUEST',
  SIMULATE_ASAAS_PAYMENT_SUCCESS: 'ASAAS_SIMULATE_PAYMENT_SUCCESS',
  SIMULATE_ASAAS_PAYMENT_ERROR: 'ASAAS_SIMULATE_PAYMENT_ERROR',
  SIMULATE_ASAAS_PAYMENT_CLEAR: 'ASAAS_SIMULATE_PAYMENT_CLEAR',
  LOAD_ASAAS_BALANCE_REQUEST: 'ASAAS_LOAD_BALANCE_REQUEST',
  LOAD_ASAAS_BALANCE_SUCCESS: 'ASAAS_LOAD_BALANCE_SUCCESS',
  LOAD_ASAAS_BALANCE_ERROR: 'ASAAS_LOAD_BALANCE_ERROR',
  // Fiscal Config
  GET_FISCAL_INFO_REQUEST: 'ASAAS_GET_FISCAL_INFO_REQUEST',
  GET_FISCAL_INFO_SUCCESS: 'ASAAS_GET_FISCAL_INFO_SUCCESS',
  GET_FISCAL_INFO_ERROR: 'ASAAS_GET_FISCAL_INFO_ERROR',
  SAVE_FISCAL_INFO_REQUEST: 'ASAAS_SAVE_FISCAL_INFO_REQUEST',
  SAVE_FISCAL_INFO_SUCCESS: 'ASAAS_SAVE_FISCAL_INFO_SUCCESS',
  SAVE_FISCAL_INFO_ERROR: 'ASAAS_SAVE_FISCAL_INFO_ERROR',
  GET_MUNICIPAL_OPTIONS_REQUEST: 'ASAAS_GET_MUNICIPAL_OPTIONS_REQUEST',
  GET_MUNICIPAL_OPTIONS_SUCCESS: 'ASAAS_GET_MUNICIPAL_OPTIONS_SUCCESS',
  GET_MUNICIPAL_OPTIONS_ERROR: 'ASAAS_GET_MUNICIPAL_OPTIONS_ERROR',
  LIST_MUNICIPAL_SERVICES_REQUEST: 'ASAAS_LIST_MUNICIPAL_SERVICES_REQUEST',
  LIST_MUNICIPAL_SERVICES_SUCCESS: 'ASAAS_LIST_MUNICIPAL_SERVICES_SUCCESS',
  LIST_MUNICIPAL_SERVICES_ERROR: 'ASAAS_LIST_MUNICIPAL_SERVICES_ERROR',
  // Invoice Defaults
  GET_INVOICE_DEFAULTS_REQUEST: 'ASAAS_GET_INVOICE_DEFAULTS_REQUEST',
  GET_INVOICE_DEFAULTS_SUCCESS: 'ASAAS_GET_INVOICE_DEFAULTS_SUCCESS',
  GET_INVOICE_DEFAULTS_ERROR: 'ASAAS_GET_INVOICE_DEFAULTS_ERROR',
  SAVE_INVOICE_DEFAULTS_REQUEST: 'ASAAS_SAVE_INVOICE_DEFAULTS_REQUEST',
  SAVE_INVOICE_DEFAULTS_SUCCESS: 'ASAAS_SAVE_INVOICE_DEFAULTS_SUCCESS',
  SAVE_INVOICE_DEFAULTS_ERROR: 'ASAAS_SAVE_INVOICE_DEFAULTS_ERROR',
  // Notification Defaults (padrão de notificações de cobrança)
  GET_NOTIFICATION_DEFAULTS_REQUEST: 'ASAAS_GET_NOTIFICATION_DEFAULTS_REQUEST',
  GET_NOTIFICATION_DEFAULTS_SUCCESS: 'ASAAS_GET_NOTIFICATION_DEFAULTS_SUCCESS',
  GET_NOTIFICATION_DEFAULTS_ERROR: 'ASAAS_GET_NOTIFICATION_DEFAULTS_ERROR',
  SAVE_NOTIFICATION_DEFAULTS_REQUEST: 'ASAAS_SAVE_NOTIFICATION_DEFAULTS_REQUEST',
  SAVE_NOTIFICATION_DEFAULTS_SUCCESS: 'ASAAS_SAVE_NOTIFICATION_DEFAULTS_SUCCESS',
  SAVE_NOTIFICATION_DEFAULTS_ERROR: 'ASAAS_SAVE_NOTIFICATION_DEFAULTS_ERROR',
  APPLY_NOTIFICATION_DEFAULTS_REQUEST: 'ASAAS_APPLY_NOTIFICATION_DEFAULTS_REQUEST',
  APPLY_NOTIFICATION_DEFAULTS_PROGRESS: 'ASAAS_APPLY_NOTIFICATION_DEFAULTS_PROGRESS',
  APPLY_NOTIFICATION_DEFAULTS_SUCCESS: 'ASAAS_APPLY_NOTIFICATION_DEFAULTS_SUCCESS',
  APPLY_NOTIFICATION_DEFAULTS_ERROR: 'ASAAS_APPLY_NOTIFICATION_DEFAULTS_ERROR',
  // Customers (clientes Asaas da subconta)
  LIST_ASAAS_CUSTOMERS_REQUEST: 'ASAAS_LIST_ASAAS_CUSTOMERS_REQUEST',
  LIST_ASAAS_CUSTOMERS_SUCCESS: 'ASAAS_LIST_ASAAS_CUSTOMERS_SUCCESS',
  LIST_ASAAS_CUSTOMERS_ERROR: 'ASAAS_LIST_ASAAS_CUSTOMERS_ERROR',
  SYNC_ASAAS_CUSTOMER_REQUEST: 'ASAAS_SYNC_ASAAS_CUSTOMER_REQUEST',
  SYNC_ASAAS_CUSTOMER_SUCCESS: 'ASAAS_SYNC_ASAAS_CUSTOMER_SUCCESS',
  SYNC_ASAAS_CUSTOMER_ERROR: 'ASAAS_SYNC_ASAAS_CUSTOMER_ERROR',
  GET_CUSTOMER_NOTIFICATIONS_REQUEST: 'ASAAS_GET_CUSTOMER_NOTIFICATIONS_REQUEST',
  GET_CUSTOMER_NOTIFICATIONS_SUCCESS: 'ASAAS_GET_CUSTOMER_NOTIFICATIONS_SUCCESS',
  GET_CUSTOMER_NOTIFICATIONS_ERROR: 'ASAAS_GET_CUSTOMER_NOTIFICATIONS_ERROR',
  UPDATE_CUSTOMER_NOTIFICATIONS_REQUEST: 'ASAAS_UPDATE_CUSTOMER_NOTIFICATIONS_REQUEST',
  UPDATE_CUSTOMER_NOTIFICATIONS_SUCCESS: 'ASAAS_UPDATE_CUSTOMER_NOTIFICATIONS_SUCCESS',
  UPDATE_CUSTOMER_NOTIFICATIONS_ERROR: 'ASAAS_UPDATE_CUSTOMER_NOTIFICATIONS_ERROR',
  // Account Fees (tela de taxas da subconta)
  GET_ACCOUNT_FEES_REQUEST: 'ASAAS_GET_ACCOUNT_FEES_REQUEST',
  GET_ACCOUNT_FEES_SUCCESS: 'ASAAS_GET_ACCOUNT_FEES_SUCCESS',
  GET_ACCOUNT_FEES_ERROR: 'ASAAS_GET_ACCOUNT_FEES_ERROR',
  // Commercial Info (PJ Upgrade)
  UPDATE_COMMERCIAL_INFO_REQUEST: 'ASAAS_UPDATE_COMMERCIAL_INFO_REQUEST',
  UPDATE_COMMERCIAL_INFO_SUCCESS: 'ASAAS_UPDATE_COMMERCIAL_INFO_SUCCESS',
  UPDATE_COMMERCIAL_INFO_ERROR: 'ASAAS_UPDATE_COMMERCIAL_INFO_ERROR',
  DISCARD_REJECTED_ACCOUNT_REQUEST: 'ASAAS_DISCARD_REJECTED_ACCOUNT_REQUEST',
  DISCARD_REJECTED_ACCOUNT_SUCCESS: 'ASAAS_DISCARD_REJECTED_ACCOUNT_SUCCESS',
  DISCARD_REJECTED_ACCOUNT_ERROR: 'ASAAS_DISCARD_REJECTED_ACCOUNT_ERROR',
  // Invoice Patient
  FETCH_INVOICE_PATIENT_REQUEST: 'ASAAS_FETCH_INVOICE_PATIENT_REQUEST',
  FETCH_INVOICE_PATIENT_SUCCESS: 'ASAAS_FETCH_INVOICE_PATIENT_SUCCESS',
  FETCH_INVOICE_PATIENT_ERROR: 'ASAAS_FETCH_INVOICE_PATIENT_ERROR',
  // Invoice Procedures
  FETCH_INVOICE_PROCEDURES_REQUEST: 'ASAAS_FETCH_INVOICE_PROCEDURES_REQUEST',
  FETCH_INVOICE_PROCEDURES_SUCCESS: 'ASAAS_FETCH_INVOICE_PROCEDURES_SUCCESS',
  FETCH_INVOICE_PROCEDURES_ERROR: 'ASAAS_FETCH_INVOICE_PROCEDURES_ERROR',
  // Invoice Operations
  CREATE_INVOICE_REQUEST: 'ASAAS_CREATE_INVOICE_REQUEST',
  CREATE_INVOICE_SUCCESS: 'ASAAS_CREATE_INVOICE_SUCCESS',
  CREATE_INVOICE_ERROR: 'ASAAS_CREATE_INVOICE_ERROR',
  RESET_CREATE_INVOICE: 'ASAAS_RESET_CREATE_INVOICE',
  GET_INVOICE_REQUEST: 'ASAAS_GET_INVOICE_REQUEST',
  GET_INVOICE_SUCCESS: 'ASAAS_GET_INVOICE_SUCCESS',
  GET_INVOICE_ERROR: 'ASAAS_GET_INVOICE_ERROR',
  LIST_INVOICES_REQUEST: 'ASAAS_LIST_INVOICES_REQUEST',
  LIST_INVOICES_SUCCESS: 'ASAAS_LIST_INVOICES_SUCCESS',
  LIST_INVOICES_ERROR: 'ASAAS_LIST_INVOICES_ERROR',
  // Transfers (Saque)
  CREATE_TRANSFER_REQUEST: 'ASAAS_CREATE_TRANSFER_REQUEST',
  CREATE_TRANSFER_SUCCESS: 'ASAAS_CREATE_TRANSFER_SUCCESS',
  CREATE_TRANSFER_ERROR: 'ASAAS_CREATE_TRANSFER_ERROR',
  CREATE_TRANSFER_RESET: 'ASAAS_CREATE_TRANSFER_RESET',
  LIST_TRANSFERS_REQUEST: 'ASAAS_LIST_TRANSFERS_REQUEST',
  LIST_TRANSFERS_SUCCESS: 'ASAAS_LIST_TRANSFERS_SUCCESS',
  LIST_TRANSFERS_ERROR: 'ASAAS_LIST_TRANSFERS_ERROR',
  // Chave PIX de saque (Segurança)
  SAVE_WITHDRAW_PIX_KEY_REQUEST: 'ASAAS_SAVE_WITHDRAW_PIX_KEY_REQUEST',
  SAVE_WITHDRAW_PIX_KEY_SUCCESS: 'ASAAS_SAVE_WITHDRAW_PIX_KEY_SUCCESS',
  SAVE_WITHDRAW_PIX_KEY_ERROR: 'ASAAS_SAVE_WITHDRAW_PIX_KEY_ERROR',
  LOOKUP_WITHDRAW_PIX_KEY_REQUEST: 'ASAAS_LOOKUP_WITHDRAW_PIX_KEY_REQUEST',
  LOOKUP_WITHDRAW_PIX_KEY_SUCCESS: 'ASAAS_LOOKUP_WITHDRAW_PIX_KEY_SUCCESS',
  LOOKUP_WITHDRAW_PIX_KEY_ERROR: 'ASAAS_LOOKUP_WITHDRAW_PIX_KEY_ERROR',
  LOOKUP_WITHDRAW_PIX_KEY_RESET: 'ASAAS_LOOKUP_WITHDRAW_PIX_KEY_RESET',
  GET_WITHDRAW_KEY_HISTORY_REQUEST: 'ASAAS_GET_WITHDRAW_KEY_HISTORY_REQUEST',
  GET_WITHDRAW_KEY_HISTORY_SUCCESS: 'ASAAS_GET_WITHDRAW_KEY_HISTORY_SUCCESS',
  GET_WITHDRAW_KEY_HISTORY_ERROR: 'ASAAS_GET_WITHDRAW_KEY_HISTORY_ERROR',
  // Financial Transactions (Extrato)
  LIST_FINANCIAL_TRANSACTIONS_REQUEST: 'ASAAS_LIST_FINANCIAL_TRANSACTIONS_REQUEST',
  LIST_FINANCIAL_TRANSACTIONS_SUCCESS: 'ASAAS_LIST_FINANCIAL_TRANSACTIONS_SUCCESS',
  LIST_FINANCIAL_TRANSACTIONS_ERROR: 'ASAAS_LIST_FINANCIAL_TRANSACTIONS_ERROR',
  // Anticipations (Antecipação de Recebíveis)
  SIMULATE_ANTICIPATION_REQUEST: 'ASAAS_SIMULATE_ANTICIPATION_REQUEST',
  SIMULATE_ANTICIPATION_SUCCESS: 'ASAAS_SIMULATE_ANTICIPATION_SUCCESS',
  SIMULATE_ANTICIPATION_ERROR: 'ASAAS_SIMULATE_ANTICIPATION_ERROR',
  SIMULATE_ANTICIPATION_CLEAR: 'ASAAS_SIMULATE_ANTICIPATION_CLEAR',
  REQUEST_ANTICIPATION_REQUEST: 'ASAAS_REQUEST_ANTICIPATION_REQUEST',
  REQUEST_ANTICIPATION_SUCCESS: 'ASAAS_REQUEST_ANTICIPATION_SUCCESS',
  REQUEST_ANTICIPATION_ERROR: 'ASAAS_REQUEST_ANTICIPATION_ERROR',
  LIST_ANTICIPATIONS_REQUEST: 'ASAAS_LIST_ANTICIPATIONS_REQUEST',
  LIST_ANTICIPATIONS_SUCCESS: 'ASAAS_LIST_ANTICIPATIONS_SUCCESS',
  LIST_ANTICIPATIONS_ERROR: 'ASAAS_LIST_ANTICIPATIONS_ERROR',
  GET_ANTICIPATION_LIMITS_REQUEST: 'ASAAS_GET_ANTICIPATION_LIMITS_REQUEST',
  GET_ANTICIPATION_LIMITS_SUCCESS: 'ASAAS_GET_ANTICIPATION_LIMITS_SUCCESS',
  GET_ANTICIPATION_LIMITS_ERROR: 'ASAAS_GET_ANTICIPATION_LIMITS_ERROR',
  CANCEL_ANTICIPATION_REQUEST: 'ASAAS_CANCEL_ANTICIPATION_REQUEST',
  CANCEL_ANTICIPATION_SUCCESS: 'ASAAS_CANCEL_ANTICIPATION_SUCCESS',
  CANCEL_ANTICIPATION_ERROR: 'ASAAS_CANCEL_ANTICIPATION_ERROR',
  // Acesso de secretárias (walletAccess)
  SELECT_WALLET_OWNER: 'ASAAS_SELECT_WALLET_OWNER',
  SAVE_WALLET_ACCESS_REQUEST: 'ASAAS_SAVE_WALLET_ACCESS_REQUEST',
  SAVE_WALLET_ACCESS_SUCCESS: 'ASAAS_SAVE_WALLET_ACCESS_SUCCESS',
  SAVE_WALLET_ACCESS_ERROR: 'ASAAS_SAVE_WALLET_ACCESS_ERROR',
  LOAD_WALLET_AUDIT_REQUEST: 'ASAAS_LOAD_WALLET_AUDIT_REQUEST',
  LOAD_WALLET_AUDIT_SUCCESS: 'ASAAS_LOAD_WALLET_AUDIT_SUCCESS',
  LOAD_WALLET_AUDIT_ERROR: 'ASAAS_LOAD_WALLET_AUDIT_ERROR',
  loadAsaasAccount: () => ({
    type: actions.LOAD_ASAAS_ACCOUNT_REQUEST,
  }),
  setupAsaasAccount: (formData) => ({
    type: actions.SETUP_ASAAS_ACCOUNT_REQUEST,
    payload: formData,
  }),
  getAsaasAccountStatus: () => ({
    type: actions.GET_ASAAS_ACCOUNT_STATUS_REQUEST,
  }),
  searchZipCode: (code) => ({
    type: actions.SEARCH_ZIP_CODE_REQUEST,
    payload: code,
  }),
  loadAsaasFees: () => ({
    type: actions.LOAD_ASAAS_FEES_REQUEST,
  }),
  cancelAsaasCharge: (chargeKey) => ({
    type: actions.CANCEL_ASAAS_CHARGE_REQUEST,
    payload: { chargeKey },
  }),
  refundAsaasCharge: (chargeKey, description, asaasPaymentId) => ({
    type: actions.REFUND_ASAAS_CHARGE_REQUEST,
    payload: { chargeKey, description, asaasPaymentId },
  }),
  checkRefundStatus: (chargeKey, asaasPaymentId) => ({
    type: actions.CHECK_REFUND_STATUS_REQUEST,
    payload: { chargeKey, asaasPaymentId },
  }),
  loadAsaasCharges: ({ startDate, endDate } = {}) => ({
    type: actions.LOAD_ASAAS_CHARGES_REQUEST,
    payload: { startDate, endDate },
  }),
  asaasGetCheckoutInfo: (checkoutKey, silent = false) => ({
    type: actions.GET_CHECKOUT_INFO_REQUEST,
    payload: { checkoutKey, silent },
  }),
  asaasValidateCheckoutCpf: (checkoutKey, cpfSuffix) => ({
    type: actions.VALIDATE_CHECKOUT_CPF_REQUEST,
    payload: { checkoutKey, cpfSuffix },
  }),
  asaasCreatePublicCharge: (payload) => ({
    type: actions.CREATE_PUBLIC_CHARGE_REQUEST,
    payload,
  }),
  asaasClearCheckoutCharge: () => ({
    type: actions.CLEAR_CHECKOUT_CHARGE,
  }),
  asaasCreateCheckoutCharge: (checkoutKey, billingType, installmentCount = 1) => ({
    type: actions.CREATE_CHECKOUT_CHARGE_REQUEST,
    payload: { checkoutKey, billingType, installmentCount },
  }),
  simulateAsaasPayment: (itemKey, value, maxInstallments, professional) => ({
    type: actions.SIMULATE_ASAAS_PAYMENT_REQUEST,
    payload: {
      itemKey,
      value,
      maxInstallments,
      professional,
    },
  }),
  clearAsaasSimulation: (itemKey) => ({
    type: actions.SIMULATE_ASAAS_PAYMENT_CLEAR,
    payload: itemKey,
  }),
  loadAsaasBalance: ({ startDate, endDate } = {}) => ({
    type: actions.LOAD_ASAAS_BALANCE_REQUEST,
    payload: { startDate, endDate },
  }),
  // Fiscal Config
  getFiscalInfo: () => ({
    type: actions.GET_FISCAL_INFO_REQUEST,
  }),
  saveFiscalInfo: (payload) => ({
    type: actions.SAVE_FISCAL_INFO_REQUEST,
    payload,
  }),
  getMunicipalOptions: () => ({
    type: actions.GET_MUNICIPAL_OPTIONS_REQUEST,
  }),
  listMunicipalServices: (description) => ({
    type: actions.LIST_MUNICIPAL_SERVICES_REQUEST,
    payload: { description },
  }),
  // Invoice Defaults
  getInvoiceDefaults: () => ({
    type: actions.GET_INVOICE_DEFAULTS_REQUEST,
  }),
  saveInvoiceDefaults: (payload) => ({
    type: actions.SAVE_INVOICE_DEFAULTS_REQUEST,
    payload,
  }),
  // Notification Defaults
  getNotificationDefaults: () => ({
    type: actions.GET_NOTIFICATION_DEFAULTS_REQUEST,
  }),
  saveNotificationDefaults: ({ notificationDisabled, items, applyToExisting } = {}) => ({
    type: actions.SAVE_NOTIFICATION_DEFAULTS_REQUEST,
    payload: { notificationDisabled, items, applyToExisting },
  }),
  applyNotificationDefaults: () => ({
    type: actions.APPLY_NOTIFICATION_DEFAULTS_REQUEST,
  }),
  // Customers
  listAsaasCustomers: ({ offset, limit, name } = {}) => ({
    type: actions.LIST_ASAAS_CUSTOMERS_REQUEST,
    payload: { offset, limit, name },
  }),
  getCustomerNotifications: (customerId) => ({
    type: actions.GET_CUSTOMER_NOTIFICATIONS_REQUEST,
    payload: { customerId },
  }),
  syncAsaasCustomer: (customerId) => ({
    type: actions.SYNC_ASAAS_CUSTOMER_REQUEST,
    payload: { customerId },
  }),
  updateCustomerNotifications: ({ customerId, notificationDisabled, notifications } = {}) => ({
    type: actions.UPDATE_CUSTOMER_NOTIFICATIONS_REQUEST,
    payload: { customerId, notificationDisabled, notifications },
  }),
  getAccountFees: () => ({
    type: actions.GET_ACCOUNT_FEES_REQUEST,
  }),
  // Commercial Info (PJ Upgrade / Annual Confirmation)
  updateCommercialInfo: (payload, context) => ({
    type: actions.UPDATE_COMMERCIAL_INFO_REQUEST,
    payload,
    meta: { context }, // 'pjUpgrade' | 'annualConfirmation'
  }),
  discardRejectedAccount: () => ({
    type: actions.DISCARD_REJECTED_ACCOUNT_REQUEST,
  }),
  // Invoice Patient
  fetchInvoicePatient: (patientId) => ({
    type: actions.FETCH_INVOICE_PATIENT_REQUEST,
    payload: { patientId },
  }),
  // Invoice Procedures
  fetchInvoiceProcedures: ({ sourceId, sourceType }) => ({
    type: actions.FETCH_INVOICE_PROCEDURES_REQUEST,
    payload: { sourceId, sourceType },
  }),
  // Invoice Operations
  createInvoice: (payload) => ({
    type: actions.CREATE_INVOICE_REQUEST,
    payload,
  }),
  resetCreateInvoice: () => ({
    type: actions.RESET_CREATE_INVOICE,
  }),
  getInvoice: (invoiceId) => ({
    type: actions.GET_INVOICE_REQUEST,
    payload: { invoiceId },
  }),
  listInvoices: ({ offset, limit, status } = {}) => ({
    type: actions.LIST_INVOICES_REQUEST,
    payload: { offset, limit, status },
  }),
  // Transfers (Saque)
  createTransfer: (payload) => ({
    type: actions.CREATE_TRANSFER_REQUEST,
    payload,
  }),
  resetCreateTransfer: () => ({
    type: actions.CREATE_TRANSFER_RESET,
  }),
  listTransfers: (payload) => ({
    type: actions.LIST_TRANSFERS_REQUEST,
    payload,
  }),
  // Chave PIX de saque (Segurança)
  saveWithdrawPixKey: (payload) => ({
    type: actions.SAVE_WITHDRAW_PIX_KEY_REQUEST,
    payload,
  }),
  lookupWithdrawPixKey: (payload) => ({
    type: actions.LOOKUP_WITHDRAW_PIX_KEY_REQUEST,
    payload,
  }),
  resetWithdrawPixKeyLookup: () => ({
    type: actions.LOOKUP_WITHDRAW_PIX_KEY_RESET,
  }),
  getWithdrawKeyHistory: () => ({
    type: actions.GET_WITHDRAW_KEY_HISTORY_REQUEST,
  }),
  // Financial Transactions (Extrato)
  listFinancialTransactions: (payload) => ({
    type: actions.LIST_FINANCIAL_TRANSACTIONS_REQUEST,
    payload,
  }),
  // Anticipations (Antecipação de Recebíveis)
  simulateAnticipation: (payload) => ({
    type: actions.SIMULATE_ANTICIPATION_REQUEST,
    payload,
  }),
  clearAnticipationSimulation: () => ({
    type: actions.SIMULATE_ANTICIPATION_CLEAR,
  }),
  requestAnticipation: (payload) => ({
    type: actions.REQUEST_ANTICIPATION_REQUEST,
    payload,
  }),
  listAnticipations: (payload) => ({
    type: actions.LIST_ANTICIPATIONS_REQUEST,
    payload,
  }),
  getAnticipationLimits: () => ({
    type: actions.GET_ANTICIPATION_LIMITS_REQUEST,
  }),
  cancelAnticipation: (anticipationId) => ({
    type: actions.CANCEL_ANTICIPATION_REQUEST,
    payload: { anticipationId },
  }),
  // Acesso de secretárias (walletAccess)
  selectWalletOwner: (professionalUid) => ({
    type: actions.SELECT_WALLET_OWNER,
    payload: professionalUid,
  }),
  saveWalletAccess: (walletAccess) => ({
    type: actions.SAVE_WALLET_ACCESS_REQUEST,
    payload: { walletAccess },
  }),
  loadWalletAudit: ({ uid, type, days } = {}) => ({
    type: actions.LOAD_WALLET_AUDIT_REQUEST,
    payload: { uid, type, days },
  }),
};

export default actions;
